export default __webpack_public_path__ + "static/media/webull.4557f5c7.svg";